/**
 * frontend-simple.js
 * P7 Simple Slider - Frontend & Editor Initialization
 */

(function () {
    // Initialize a single slider block
    function initSimpleP7Slider(sliderBlock) {
        if (!sliderBlock || sliderBlock.classList.contains('p7-slider-initialized')) return;

        const sliderEl = sliderBlock.querySelector('.p7-simple-slider');
        if (!sliderEl || typeof Swiper === 'undefined') {
            console.log('Swiper not found or slider element missing.');
            return;
        }

        const autoPlay = sliderBlock.dataset.autoplay === 'true';
        const loop = sliderBlock.dataset.loop !== 'false';
        const delay = parseInt(sliderBlock.dataset.delay) || 5000;
        const showNav = sliderBlock.dataset.navigation !== 'false';

        const swiperOptions = {
            slidesPerView: 1,
            loop: loop,
            autoplay: autoPlay
                ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
                : false,
            navigation: showNav
                ? {
                      nextEl: sliderBlock.querySelector('.swiper-simple-button-next'),
                      prevEl: sliderBlock.querySelector('.swiper-simple-button-prev'),
                  }
                : false,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
        };

        // Optional: add pagination if element exists
        const paginationEl = sliderBlock.querySelector('.swiper-pagination');
        if (paginationEl) {
            swiperOptions.pagination = {
                el: paginationEl,
                clickable: true,
            };
        }

        const swiperInstance = new Swiper(sliderEl, swiperOptions);
        sliderBlock.swiperInstance = swiperInstance;
        sliderBlock.classList.add('p7-slider-initialized');
    }

    // Initialize all uninitialized sliders
    function initAllSimpleP7Sliders() {
        document.querySelectorAll('.p7-simple-slider-block:not(.p7-slider-initialized)').forEach(initSimpleP7Slider);
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllSimpleP7Sliders);
    } else {
        initAllSimpleP7Sliders();
    }

    // Gutenberg editor support
    if (typeof wp !== 'undefined' && wp.data && wp.data.subscribe) {
        let timeout;
        wp.data.subscribe(() => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                document.querySelectorAll('.p7-simple-slider-block.p7-slider-initialized').forEach((block) => {
                    if (block.swiperInstance) block.swiperInstance.destroy(true, true);
                    block.classList.remove('p7-slider-initialized');
                });
                initAllSimpleP7Sliders();
            }, 100);
        });
    }

    // Global control
    window.p7SimpleSlider = {
        init: initSimpleP7Slider,
        initAll: initAllSimpleP7Sliders,
        destroyAll: () => {
            document.querySelectorAll('.p7-simple-slider-block.p7-slider-initialized').forEach((block) => {
                if (block.swiperInstance) block.swiperInstance.destroy(true, true);
                block.classList.remove('p7-slider-initialized');
            });
        },
    };
})();
